import React from "react";
import { Tooltip } from 'antd';
import useSmalLogout from "../auth/SAMLLogout"; // adjust path as needed
import veoliaLogo from "../../assets/Logo-dark.png";
import { useAuthContext } from "../../utils/AuthContext";
const Header = ({ userEmail1, logo, clearIndexedDB }) => {
  const { handleLogout } = useSmalLogout(clearIndexedDB);
    const { user} = useAuthContext(); 
    const userEmail =  user?.email

  const handleHelpClick = () => {
    const formUrl = "https://docs.google.com/forms/d/e/1FAIpQLSd4WzWJAoj66mpec244vFK4ktYv_zttEO5CCekwcv-zXQffxQ/viewform";
    window.open(formUrl, "_blank");
  };

  return (
    <div className="card bg-light shadow-sm p-1" style={{ borderRadius: "0", position: "sticky", top: "0", zIndex: 1000, backgroundColor: "#fff" }}>
      <div className="d-flex justify-content-between align-items-center gap-2 pe-3 py-1">
        <div className="d-flex justify-content-start align-items-start">
          <img src={veoliaLogo} alt="smart-growth-engine" style={{ height: "40px", marginLeft: "20px" }} />
        </div>
        <div className='d-flex justify-content-end align-items-end'>
          <h6 className="mb-1.5 text-secondary me-2">{userEmail}</h6>
          <Tooltip title="Feedback" placement="top">
            <i className="bi bi-question-circle fs-5 text-primary" style={{ cursor: "pointer", marginRight: "10px" }} onClick={handleHelpClick}></i>
          </Tooltip>
          <Tooltip title="Logout" placement="top">
            <i className="bi bi-box-arrow-right fs-5 text-primary" style={{ cursor: "pointer" }} onClick={handleLogout}></i>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default Header;
